import { render, staticRenderFns } from "./AboutStyleOne.vue?vue&type=template&id=d777828c&"
import script from "./AboutStyleOne.vue?vue&type=script&lang=js&"
export * from "./AboutStyleOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports